import React from "react";
import { useContent } from "../context/ContentContext";
import SafeImage from "../components/SafeImage";

export default function Products() {
  const { content } = useContent();
  const { title = "Our Products", items = [] } = content.products || {};
  return (
    <div className="container py-4">
      <h1 className="mb-4 text-success">{title}</h1>
      <div className="row g-4">
        {items.map((product, i) => (
          <div key={i} className="col-md-4">
            <div className="card h-100 shadow-sm">
              <SafeImage src={product.image} className="card-img-top" alt={product.name} style={{ height: 200, objectFit: "cover" }} />
              <div className="card-body">
                <h5 className="card-title text-success">{product.name}</h5>
                <p className="card-text">{product.description}</p>
                <p className="card-text"><strong>Availability:</strong> {product.availability}</p>
                <p className="card-text"><strong>Methods:</strong> {product.methods}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
